module.exports = __webpack_public_path__ + "img/Chart_red.4630371d.svg";